import { Component, OnInit, OnDestroy, ElementRef, PLATFORM_ID, Inject, Renderer2, HostListener } from '@angular/core';
import { isPlatformBrowser, DOCUMENT } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { WebsiteService } from 'src/app/_services/website.service';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
// import * as $ from 'jquery';
import { LinkService } from '../../_services/langhfre.service';
import { LoadScriptService } from 'src/app/_services/load-script.service';
import { NavigationService } from 'src/app/_services/navigation.service';
import { environment } from 'src/environments/environment';
import { AnalyticsService } from 'src/app/_services/analytics.service';
// import { analyzeAndValidateNgModules } from '@angular/compiler';

//declare function ire(string,{}): any;

@Component({
  selector: 'app-pricing',
  templateUrl: './pricing.component.html',
  styleUrls: ['./pricing.component.scss']
})
export class PricingComponent implements OnInit, OnDestroy {
  isYearlyChecked: boolean = true;
  formSection: boolean = true;
  thankSection: boolean = false;
  contactForm: FormGroup;
  disabledSubmitButton: boolean = true;
  contactUsSection: String;
  monthfinalSection: boolean = false;
  YearlyfinalSection: boolean = true;
  country: string;
  encodedData: any;
  decodedData: any;
  paymentModeOption: any;
  finalAmmount: any;
  isSticky = false;
  isSubmitting: boolean = false;
  activeTab: string = 'individuals';
  Math = Math; 
  trinkaCloudUrl = environment.trinkaCloudUrl;
  countryLoaded = false;
  countryCode = '';
  showDiscount = false;
  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    private networkCall: WebsiteService,
    private toastr: ToastrService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    public paymentService: WebsiteService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private LinkService: LinkService,
    private router: Router,
    private _renderer2: Renderer2,
    private el: ElementRef, private renderer: Renderer2,
    @Inject(DOCUMENT) private _document: Document,
    @Inject(DOCUMENT) private document: Document,
    public loadScript: LoadScriptService,
    public navigationService: NavigationService,
    private analyticsService: AnalyticsService
  ) {
    
    this.document.body.classList.add('nosnipptFooter');
  }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {

      const savedCountry = localStorage.getItem('country-trinka');
    
      if (savedCountry) {
    
        this.countryCode = savedCountry;
        this.countryLoaded = true;
        this.fetchPlans();
        this.updatePricingState();
      } else {
    
        this.loadGeoAPIScript();
    
      }
    
    }
    this.titleService.setTitle('Trinka Pricing Plans - Powerful Writing at Attractive Value');
    this.metaTagService.updateTag({ name: 'description', content: "Write better for free with Trinka's Basic Plan. Upgrade to Premium subscription to get powerful writing assistance at the best value." });
    this.metaTagService.updateTag({ property: 'og:title', content: 'Trinka Pricing Plans - Powerful Writing at Attractive Value' });
    this.metaTagService.updateTag({ property: 'og:description', content: "Write better for free with Trinka's Basic Plan. Upgrade to Premium subscription to get powerful writing assistance at the best value." });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/pricing' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/Trinka.jpg' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: 'Trinka Pricing Plans - Powerful Writing at Attractive Value' });
    this.metaTagService.updateTag({ name: 'twitter:description', content: "Write better for free with Trinka's Basic Plan. Upgrade to Premium subscription to get powerful writing assistance at the best value." });
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://www.trinka.ai/assets/images/Trinka.jpg' });
    this.metaTagService.updateTag({ name: 'language', content: 'en-us' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/pricing' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/pricing' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/pricing' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/pricing' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/pricing' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/pricing' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/pricing' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/pricing' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/pricing' });
    let script = this._renderer2.createElement('script');
    script.type = `application/ld+json`;
    script.text = `
    {"@context":"https://schema.org/","@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"Trinka AI","item":"https://www.trinka.ai/"},{"@type":"ListItem","position":2,"name":"Trinka AI Pricing","item":"https://www.trinka.ai/pricing"}]}
    `;
    
    this._renderer2.appendChild(this._document.head, script);
    this.activeTab = 'individuals'; // Set the default tab immediately

    this.route.fragment.subscribe((fragment: string | null) => {
      this.activeTab = fragment ? fragment.toLowerCase() : 'individuals';
      this.setTab(this.activeTab);
    });

    this.currentTestimonials = this.individuals;
    //ire('identify', { 'customerId': '', customerEmail: '', customProfileId: '' });
  }

  get isIndonesia(): boolean {
    return this.countryCode === 'ID';
  }

  updatePricingState() {
    this.showDiscount = 
      this.countryLoaded &&
      this.isYearlyChecked &&
      this.countryCode !== 'MY' &&
      this.countryCode !== 'ID' &&
      this.countryCode !== 'GB';
  }

  loadGeoAPIScript() {
    if (isPlatformBrowser(this.platformId)) {
  
      const scriptName = "geoIP";
  
      this.loadScript.loadScript(
        scriptName,
        '//geoip-js.com/js/apis/geoip2/v2.1/geoip2.js'
      )
      .then(() => {
  
        console.log(`${scriptName} loaded successfully`);
  
        const onSuccess = (location) => {
  
          this.countryCode = location.country.iso_code;
  
          localStorage.setItem(
            "country-trinka",
            this.countryCode
          );
  
          this.countryLoaded = true;
          this.updatePricingState();
  
          this.fetchPlans();
        };
  
  
        const onError = (error) => {
  
          console.error('GeoIP error:', error);
  
          this.countryCode = "IN";
  
          localStorage.setItem(
            "country-trinka",
            this.countryCode
          );
  
          this.countryLoaded = true;
          this.updatePricingState();
  
          this.fetchPlans();
        };
  
  
        try {
          // @ts-ignore
          geoip2.city(onSuccess, onError);
  
        } catch (error) {
          console.error('GeoIP catch error:', error);
        }
  
      })
      .catch(() => {
        console.error(`Failed to load ${scriptName}`);
      });
    }
  }
  

  fetchPlans() {
    this.country = this.countryCode;
    this.route.params.subscribe(params => {
      this.encodedData = params['id'];
      this.paymentService.getPlans(this.encodedData, 1).subscribe(resp => {
        if (resp['message'] === 'success') {
          this.decodedData = resp['data'];
          this.decodedData.sort((a, b) => a.index - b.index);
          this.paymentModeOption = this.decodedData;
          console.log("Country is: ", this.country);
          const annualAmount = this.decodedData[3].final_amount;
          this.finalAmmount = annualAmount / 12;
        }
      });
    });
  }
  
  
  monthyPricing() {
    this.monthfinalSection = true;
    this.YearlyfinalSection = false;
  }
  yearlyPricing() {
    this.monthfinalSection = false;
    this.YearlyfinalSection = true;
  }
  //   scroll(el: HTMLElement) {
  //     el.scrollIntoView();
  // }
  scroll(el: HTMLElement) {
    el.scrollIntoView({ behavior: 'smooth' });
  }
  ngOnDestroy() {
    if (isPlatformBrowser(this.platformId)) {
      //document.getElementById('main_header').classList.remove('pricingPageHeader');
      this.document.body.classList.remove('nosnipptFooter');
    }
  }

  buildPlanCheckoutUrl(
    planType: string,
    opts: { isAnnual?: boolean; coupon?: string } = {}
  ) {
    const {
      isAnnual = this.isYearlyChecked,
      coupon
    } = opts;
  
    const payload = {
      frmktg: true,
      go_to_payments: true,
      plan_type: planType,
      planType: planType,
      isAnnualPlan: isAnnual ? 1 : 0,
      plan_name: 'basic'
    };
  
    const encoded = btoa(encodeURIComponent(JSON.stringify(payload))).replace(/=/g, '');
  
    const couponSuffix = coupon
      ? `?cp=${encodeURIComponent(coupon)}`
      : '';
  
    return `${environment.paymentsUrl}/user/${encoded}${couponSuffix}`;
  }

  trackPricingClick(planName: string) {
    this.analyticsService.trackEvent(
      'pricing_button_click',
      { 
        plan_name: planName, 
        page: 'pricing'
      }
    );
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const element = this.el.nativeElement.querySelector('.table-container');
    const rect = element.getBoundingClientRect();

    if (rect.top <= 0) {
      // Add your CSS class when the element touches the top of the page
      this.renderer.addClass(element, 'sticky-class');
    } else {
      // Remove the CSS class when the element is not touching the top of the page
      this.renderer.removeClass(element, 'sticky-class');
    }
  }

  calculateIntegerPart(amount: number): number {
    return Math.floor(amount);
  }
  
  calculateFractionalPart(amount: number): string {
    const fractional = amount - Math.floor(amount);
    return fractional.toFixed(2).substring(1);
  }

  getOriginalPrice(finalAmount: number): number {
    if (!finalAmount) return 0;
  
    return finalAmount / 0.3333;
  }

  ngAfterViewInit(): void {
    // Set the initial active tab on page load
    const section = document.querySelector('.choosePlan') as HTMLElement;
    const tabs = document.querySelector('.pricingTabs') as HTMLElement;
  
    window.addEventListener('scroll', () => {
      const sectionTop = section.offsetTop;
      const sectionHeight = section.offsetHeight;
      const scrollY = window.scrollY;
      const tabsHeight = tabs.offsetHeight;
  
      if (scrollY > sectionTop - 70 && scrollY < sectionTop + sectionHeight - tabsHeight - 70) {
        tabs.classList.add('sticky-active');
        tabs.classList.remove('sticky-end');
      } 
      else if (scrollY >= sectionTop + sectionHeight - tabsHeight - 70) {
        tabs.classList.remove('sticky-active');
        tabs.classList.add('sticky-end');
      } 
      else {
        tabs.classList.remove('sticky-active');
        tabs.classList.remove('sticky-end');
      }
    });
  }

  

  customLogos = [
    { src: '../../../../assets/images/plagiarism-check/clients/mit.svg', width: 62, height: 33, alt: 'MIT logo', class: '' },
    { src: '../../../../assets/images/plagiarism-check/clients/IEEE.svg', width: 110, height: 32, alt: 'IEEE logo', class: '' },
    { src: '../../../../assets/images/plagiarism-check/clients/stanford.svg', width: 99, height: 44, alt: 'Stanford University logo', class: '' },
    { src: '../../../../assets/images/plagiarism-check/clients/wiley.svg', width: 114, height: 28, alt: 'Wiley logo', class: '' },
    { src: '../../../../assets/images/plagiarism-check/clients/pfizer.svg', width: 118, height: 48, alt: 'Pfizer logo', class: '' },
    { src: '../../../../assets/images/plagiarism-check/clients/abbott.svg', width: 126, height: 32, alt: 'Abbott logo', class: '' },
    { src: '../../../../assets/images/plagiarism-check/clients/princeton.svg', width: 132, height: 36, alt: 'Princeton University logo', class: '' }
  ];

  currentTestimonials: any[] = [];

  setTab(tab: string) {
    if (tab === 'individuals') {
      this.currentTestimonials = this.individuals;
    }
  
    if (tab === 'enterprise') {
      this.currentTestimonials = this.enterprise;
    }
  
    if (tab === 'institution') {
      this.currentTestimonials = this.institution;
    }
  
    setTimeout(() => {
      const carousel = (window as any).$('#individualSlider');
      if (carousel) {
        carousel.carousel(0);
      }
    }, 50);
  }
  tabs = ['individuals', 'enterprise', 'institution'];
  handleTabKeydown(event: KeyboardEvent, currentTab: string) {
    const currentIndex = this.tabs.indexOf(currentTab);

    let nextIndex = currentIndex;

    switch (event.key) {
        case 'ArrowRight':
        case 'ArrowDown':
            nextIndex = (currentIndex + 1) % this.tabs.length;
            break;

        case 'ArrowLeft':
        case 'ArrowUp':
            nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
            break;

        case 'Home':
            nextIndex = 0;
            break;

        case 'End':
            nextIndex = this.tabs.length - 1;
            break;

        default:
            return;
    }

    event.preventDefault();

    const nextTab = this.tabs[nextIndex];

    this.activeTab = nextTab;
    this.setTab(nextTab);

    setTimeout(() => {
        const tabElement = document.getElementById(`tab-${nextTab}`);
        tabElement?.focus();
    });
}

  individuals = [
    {
      "author": "Hugo Alberto Rivera Rodriguez",
      "designation": "Assistant Professor, Universidad del Rosario, Colombia",
      "message": "Trinka has allowed me to improve the articles I have published. In addition to giving me suggestions for journals according to my research.",
      "photo": "clientPhotos/hugo.webp"
    },
    {
      "author": "Michal Plaček",
      "designation": "Professor of Public and Social Policy at Charles University,<br/> Prague, Czech Republic",
      "message": "Trinka has greatly streamlined the work on my research. As a non-native English speaker, I used the services of a language editor before finalizing the article, which took weeks and cost a large amount of money. With Trinka, I can spend much more time on the research itself.",
      "photo": "clientPhotos/michal.jpg"
    },
    {
      "author": "Ikele, Chinyere Mary-Cynthia",
      "designation": "Graduate Researcher, Osaka University, Japan",
      "message": "My first time with Trinka was proofreading an article for grammatical errors and punctuation. I was amazed at the swift precision and free usage of credit granted to first-time users. In addition, Trinka occasionally hosts workshops on the accurate use of their site for academic writing, which I have greatly benefited from.",
      "photo": "clientPhotos/Mary-Cynthia.webp"
    },
  ]

  enterprise = [
    {
      "author": "Theo van Leeuwen",
      "designation": "Manager Rio Tinto Exploration SE Asia, Indonesia",
      "message": "I have been using Trinka for several years to check my scientific writings (geology). Compared to a few other programs I tried Trinka  offered the best results. Furthermore, their service in terms of answering questions has been excellent.",
      "photo": "clientPhotos/theo-van-leeuwen.jpg"
    },
    {
      "author": "Dmitry Belousov",
      "designation": "Managing Editor, Publishing House OKI",
      "message": "I have been using Trinka for several years and have had a very positive impression. This tool really helps improve the quality of writing. I especially liked the grammar and style checker, which not only found errors but also provided recommendations on how to correct them. The program interface is intuitive, which is an advantage for new users. Trinka is a versatile tool for publishing professionals. I recommend it to anyone seeking to improve their writing skills.",
      "photo": "clientPhotos/dmitry-belousov.png"
    }
  ]

  institution = [
    {
      "author": "Ömer-Faruk Kafali",
      "designation": "Assistant Professor, Ibn Haldun University School of Law Department of Civil Procedural Law and Execution & Insolvency Law, Türkiye",
      "message": "As an Assistant Professor in Law, precision and clarity are paramount in my academic writing. Trinka has become a vital tool in my workflow. Its advanced grammar and style checks, particularly its understanding of formal and academic legal English, ensure that my research papers and legal analyses are not only grammatically sound but also maintain the high standards of legal scholarly discourse. It genuinely helps me refine complex arguments and present them with the utmost clarity, saving valuable time in the editing process.",
      "photo": "clientPhotos/omer-faruk.webp"
    },
    {
      "author": "Dr. Nkhenso Sibuyi ",
      "designation": "Acting Executive Director: Library and Information Centre <br/>Executive Leadership Group Member, Research and Innovation <br/>University of Johannesburg",
      "message": "As we enter our third year of partnership with Trinka AI, this collaboration has contributed positively to the Library and Information Centre’s efforts to support academic writing. When we first adopted the tool, our goal was to provide students and researchers with resources to enhance the quality of their work. Since then, the platform has supported various aspects of the research writing process, including language refinement and publication readiness. This partnership forms part of our broader commitment to strengthening research support services at the University.",
      "photo": "clientPhotos/nkhenso.webp"
    },
    {
      "author": "Abdi Yusuf",
      "designation": "Jijiga University - Senior Lecturer and HRM Director",
      "message": "I have been using Trinka for the past year, and it has significantly improved my writing process. The advanced grammar and style suggestions have helped me refine my work, making it more polished and professional. Trinka is not just a tool; it’s an essential companion for anyone looking to enhance their writing quality. I highly recommend it to anyone who values clarity and precision in their writing.",
      "photo": "clientPhotos/abdi-yusuf.jpg"
    },
  ]
  
}
